module.exports = __webpack_public_path__ + "img/consultation.d5714c5.png?v=1747398688961";